
import React from "react";
import { useNavigate } from "react-router-dom";
import Placeholder from "./placeholder";

export default function Procurement() {
  return <Placeholder title="Procurement Management" description="Manage procurement activities, tender documents, and contract information" />;
}
